import zod from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

export const SchoolTransportationFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string().min(1, MANDATORY_FIELD),

  plate: zod.string()
    .min(1, MANDATORY_FIELD)
    .max(20, "A placa deve ter no máximo 20 caracteres.")
    .transform((val) => val.toUpperCase()),
  
  brand: zod.string()
    .max(50, "A marca deve ter no máximo 50 caracteres.")
    .nullish()
    .transform((val) => val ?? ''),

  model: zod.string()
    .max(50, "O modelo deve ter no máximo 50 caracteres.")
    .nullish()
    .transform((val) => val ?? ''),

  studentIds: zod.array(zod.number()).default([]),
  responsibleIds: zod.array(zod.number()).default([]),
});

export type SchoolTransportationFormInput = zod.infer<typeof SchoolTransportationFormSchema>;
